import React, { useRef } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'

import ProductCard from '../ProductCard'
import { Navigation } from 'swiper/modules';


import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/grid';
import 'swiper/css/pagination'
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi';
import { isMobile } from '../../service';
import { useSelector } from 'react-redux';
export const Slider = ({ item,onClick }) => {
    const productList = useSelector((state) => state.productList);
    const { loading, error, products } = productList;
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    return (
        <div className='w-full lg:px-4 py-2 flex flex-col justify-center items-center'>
            <p className='m-2 font-bold'>{item.colection.title}</p>
            <div className='w-full flex items-center justify-center'>
                <Swiper
                    modules={[Navigation]}
                    slidesPerView={isMobile()?2:5}
                    // grid={{ rows: 2, fill: 'row' }}
                    spaceBetween={10}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                        // Khi custom buttons còn null ở lần render đầu, gán reference vào swiper
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    className="custom-swiper"
                >
                    {products && products?.map((item, index) => (
                        <SwiperSlide key={index}   >
                            <ProductCard product={item}  onClick={onClick} />
                        </SwiperSlide>
                    ))}

                </Swiper>
            </div>

            {/* Custom buttons */}
            <button
                ref={prevRef}
                className="absolute left-2 top-1/2 -translate-y-1/2 z-50 p-2 bg-[--color-button-3] text-[--color-button-1] rounded-full opacity-0 group-hover/mega:opacity-100 transition-all duration-300 hover:bg-[--color-button-2]"
            >
                <HiOutlineChevronLeft />
            </button>
            <button
                ref={nextRef}
                className="absolute right-2 top-1/2 -translate-y-1/2 z-50 p-2  bg-[--color-button-3] text-[--color-button-1]  rounded-full opacity-0 group-hover/mega:opacity-100 transition-all duration-300  hover:bg-[--color-button-2]"
            >
                <HiOutlineChevronRight />
            </button>
        </div>
    )
}
